import { render, staticRenderFns } from "./BuyPlayer.vue?vue&type=template&id=604ec1e8&scoped=true&"
import script from "./BuyPlayer.vue?vue&type=script&lang=js&"
export * from "./BuyPlayer.vue?vue&type=script&lang=js&"
import style0 from "./BuyPlayer.vue?vue&type=style&index=0&id=604ec1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604ec1e8",
  null
  
)

export default component.exports